import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  featureImage: {},
 
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const FileUploadSliceME = createSlice({

  name: "fileUploadME",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      state.featureImage = {};
      // state.totalCount = 0;
      state.exportData = [];
    },
    CompanyDropdownList: (state, action) => {
        const { companyDropdownList } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.totalCount = 0;
        state.companyDropdownList = companyDropdownList;
      },
      imageUploaded: (state, action) => {
        const { entities, imageField } = action.payload;
        state.error = null;
        console.log("imageField", imageField);
        if (imageField == "featureImage") {
          state.featureImage = entities;
        }
       
        state[imageField] = entities;
      },
  }
});
